
function TestimonySlider(){

    if( $('.block-testimony__slider').length > 0 ){
        this.build();
    }

}

TestimonySlider.prototype.build = function(){

    let total = $('.swiper-slide').length;
    let rand = Math.floor( Math.random() * total );

    let swiper = new Swiper('.block-testimony__slider .swiper', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        initialSlide: rand - 1,
        loop: true,
        navigation: {
            nextEl: '.block-testimony__slider__next',
            prevEl: '.block-testimony__slider__prev',
        }
    });

};